// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: channel/channel_state_short.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "channel";

export interface ChannelStateShortProducer {
  id: string;
  paused: boolean;
}

export interface ChannelStateShortPeer {
  id: string;
  producers: ChannelStateShortProducer[];
  appDataHash?: string | undefined;
}

export interface ChannelStateShort {
  peers: ChannelStateShortPeer[];
}

function createBaseChannelStateShortProducer(): ChannelStateShortProducer {
  return { id: "", paused: false };
}

export const ChannelStateShortProducer: MessageFns<ChannelStateShortProducer> = {
  encode(message: ChannelStateShortProducer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.paused !== false) {
      writer.uint32(16).bool(message.paused);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelStateShortProducer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelStateShortProducer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.paused = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelStateShortProducer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      paused: isSet(object.paused) ? globalThis.Boolean(object.paused) : false,
    };
  },

  toJSON(message: ChannelStateShortProducer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.paused !== false) {
      obj.paused = message.paused;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelStateShortProducer>, I>>(base?: I): ChannelStateShortProducer {
    return ChannelStateShortProducer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelStateShortProducer>, I>>(object: I): ChannelStateShortProducer {
    const message = createBaseChannelStateShortProducer();
    message.id = object.id ?? "";
    message.paused = object.paused ?? false;
    return message;
  },
};

function createBaseChannelStateShortPeer(): ChannelStateShortPeer {
  return { id: "", producers: [], appDataHash: undefined };
}

export const ChannelStateShortPeer: MessageFns<ChannelStateShortPeer> = {
  encode(message: ChannelStateShortPeer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.producers) {
      ChannelStateShortProducer.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.appDataHash !== undefined) {
      writer.uint32(26).string(message.appDataHash);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelStateShortPeer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelStateShortPeer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.producers.push(ChannelStateShortProducer.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.appDataHash = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelStateShortPeer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      producers: globalThis.Array.isArray(object?.producers)
        ? object.producers.map((e: any) => ChannelStateShortProducer.fromJSON(e))
        : [],
      appDataHash: isSet(object.appDataHash) ? globalThis.String(object.appDataHash) : undefined,
    };
  },

  toJSON(message: ChannelStateShortPeer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.producers?.length) {
      obj.producers = message.producers.map((e) => ChannelStateShortProducer.toJSON(e));
    }
    if (message.appDataHash !== undefined) {
      obj.appDataHash = message.appDataHash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelStateShortPeer>, I>>(base?: I): ChannelStateShortPeer {
    return ChannelStateShortPeer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelStateShortPeer>, I>>(object: I): ChannelStateShortPeer {
    const message = createBaseChannelStateShortPeer();
    message.id = object.id ?? "";
    message.producers = object.producers?.map((e) => ChannelStateShortProducer.fromPartial(e)) || [];
    message.appDataHash = object.appDataHash ?? undefined;
    return message;
  },
};

function createBaseChannelStateShort(): ChannelStateShort {
  return { peers: [] };
}

export const ChannelStateShort: MessageFns<ChannelStateShort> = {
  encode(message: ChannelStateShort, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.peers) {
      ChannelStateShortPeer.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelStateShort {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelStateShort();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.peers.push(ChannelStateShortPeer.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelStateShort {
    return {
      peers: globalThis.Array.isArray(object?.peers)
        ? object.peers.map((e: any) => ChannelStateShortPeer.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChannelStateShort): unknown {
    const obj: any = {};
    if (message.peers?.length) {
      obj.peers = message.peers.map((e) => ChannelStateShortPeer.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelStateShort>, I>>(base?: I): ChannelStateShort {
    return ChannelStateShort.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelStateShort>, I>>(object: I): ChannelStateShort {
    const message = createBaseChannelStateShort();
    message.peers = object.peers?.map((e) => ChannelStateShortPeer.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
